import { IQuestionSet } from 'src/app/models/application-form/application-form.model';

export abstract class FormDataAbstractService {
  abstract get QuestionSets(): IQuestionSet[];
  abstract get FormId(): string;
  abstract get ContactQuestionSet(): IQuestionSet;
  abstract get ProductQuestionSet(): IQuestionSet;
  abstract get BusinessTypeQuestionSet(): IQuestionSet;
  abstract get GeneralQuestionSet(): IQuestionSet;
  abstract ResetData(): void;
}
